"use strict";
var columnSorter = function() {
  var filterFunc = function(collection, ncols, reorder) {
    var cols = [];
    var colLength = Math.floor(collection.length / ncols);
    var remainder = collection.length % ncols;
    var aktIndex = 0;
    for (var i = 0; i < ncols; ++i) {
      var actLength = colLength + (remainder-- > 0 ? 1 : 0);
      cols.push(collection.slice(aktIndex, aktIndex + actLength));
      aktIndex += actLength;
    }
    if (reorder == "col")
      return cols;
    var result = [];
    while (cols[0].length > 0) {
      var row = [];
      for (var i = 0; i < ncols; ++i) {
        if (cols[i].length > 0)
          row.push(cols[i].shift());
      }
      result.push(row);
    }
    return result;
  };
  return _.memoize(filterFunc);
};
var rowSorter = function() {
  var filterFunc = function(collection, ncols, reorder) {
    if (reorder == 'col') {
      var result = [];
      for (var i = 0; i < ncols; ++i)
        result.push([]);
      for (var i = 0; i < collection.length; ++i) {
        result[i % ncols].push(collection[i]);
      }
    } else
      return _.chunk(collection, ncols);
  };
  return _.memoize(filterFunc);
};
var uriEncode = function() {
  return window.encodeURIComponent;
};
angular.module('filters.colSort', []).filter('colSort', columnSorter);
angular.module('filters.rowSort', []).filter('rowSort', rowSorter);
var module = angular.module('filters', ['filters.colSort', 'filters.rowSort']);
module.filter('uriEncode', uriEncode);
